export const GET_PATIENT = 'patient/getPatient'
export const GET_PATIENTS = 'patient/getPatients'
export const ADD_PATIENT = 'patient/addPatient'
export const UPDATE_PATIENT = 'patient/updatePatient'
export const DELETE_PATIENT = 'patient/deletePatient'
export const ACTIVATE_PATIENT = 'patient/activatePatient'
export const SERVER_ERROR_PATIENT = 'patient/errorPatient'
export const SET_UPDATE_PATIENT = 'patient/setPatientForUpdate'
export const SET_UPDATE_PATIENT_THRESHOLD =
  'patient/setPatientThresholdForUpdate'
export const UPDATE_PATIENT_THRESHOLD = 'patient/updatePatientThreshold'
export const ADD_PATIENT_WITH_PATIENT_KEY = 'patient/addPatientWithPatientKey'
